import React from "react";
import { FaAward, FaCoins, FaStar, FaWallet } from "react-icons/fa";
import "./Bank.css";
import { formatSumma } from "../utils/format";

import ChegirmaModal from "./ChegirmaModal";

export default function Bank({ userData, onOpenPayment, onOpenCert }) {
  const [anim, setAnim] = React.useState(false);
  const [showChegirma, setShowChegirma] = React.useState(false);
  const prevScoreRef = React.useRef(0);

  const score = userData ? userData.umumiy_ball : 0;
  const balance = userData ? userData.tanga_balansi : 0;

  React.useEffect(() => {
    if (score > prevScoreRef.current) {
      // Force reset then animate
      setAnim(false);
      setTimeout(() => setAnim(true), 50);
      setTimeout(() => setAnim(false), 3100);
    }
    prevScoreRef.current = score;
  }, [score]);

  return (
    <>
      <div className="foydalanuvchi-bank-quti">
        <div
          className={`hisob ${anim ? "score-update-anim" : ""}`}
          onClick={onOpenPayment}
        >
          <FaCoins className="icon" />
          <span>{formatSumma(balance)}</span>
        </div>
        <div className="chegirma" onClick={() => setShowChegirma(true)}>
          <FaWallet className="icon" />
          <span>Chegirma</span>
        </div>
        <div className="daraja" onClick={onOpenCert} title="Sertifikat olish" style={{ cursor: 'pointer' }}>
          <FaAward className="icon" />
          <span>Sertifikat</span>
        </div>
      </div>

      {showChegirma && (
        <ChegirmaModal onClose={() => setShowChegirma(false)} />
      )}
    </>
  );
}
